var app = angular.module('leonardo');

var TemplateWorkflowService = function(BaseRestService) {
  var service = new BaseRestService('templates-workflow', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('templates-workflow', false, function(template) {
      template.addRestangularMethod('changeStatus', 'post', 'change-status');
      template.addRestangularMethod('assignUsers', 'post', 'assign-users');
      template.addRestangularMethod('assignVendors', 'post', 'assign-vendors');
      return template;
    });
  });

  service.bulkObject = function(account) {
    return {
      account: account,
      recurrence: {},
      attachments: [],
      fields: {}
    };
  };

  return service;
};

app.factory('TemplateWorkflowService', ['BaseRestService', TemplateWorkflowService]);
